import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, useTheme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MaterialTable from '@material-table/core';
import { fetchReviewerOnCases } from '@store/appAPI';
import { tableIcons } from '@utils/icons';
import { getLocalizations } from '@views/cases/components/CasesTableConfig';

const useStyles = makeStyles((theme) => ({
  titleLarge: {
    [theme.breakpoints.down('xs')]: { display: 'none' },
  },
  titleMobile: {
    display: 'none',
    padding: theme.spacing(1),
    [theme.breakpoints.down('xs')]: { display: 'inline-block' },
  },
  box: { marginBottom: theme.spacing(3) },
  root: {
    width: '100%',
  },
  table: {
    marginTop: theme.spacing(3),
    [theme.breakpoints.down('xs')]: { marginTop: theme.spacing(6) },
  },
}));

const getTableConfig = (theme, t) => {
  const columns = [
    {
      title: t('Case ID'),
      field: 'DocumentID',
    },
    {
      title: t('Reviewer email'),
      field: 'Email',
    },
  ];
  const options = {
    actionsColumnIndex: -1,
    cellStyle: {
      fontSize: '0.9rem',
    },
    headerStyle: {
      fontSize: '0.9rem',
      backgroundColor: theme.palette.action.disabledBackground,
    },
    searchFieldStyle: {
      fontSize: '0.9rem',
    },
    pageSize: 5,
    emptyRowsWhenPaging: false,
    thirdSortClick: false,
  };
  return { columns, options };
};

export const ViewReviewers = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const classes = useStyles();
  const [reviewerCases, setReviewerCases] = useState([]);
  const [loadingReviewerCases, setLoadingReviewerCases] = useState(true);

  useEffect(() => {
    const fetchReviewerData = async () => {
      try {
        const response = await fetchReviewerOnCases();
        setReviewerCases(response?.reviewers || []);
      } catch (e) {
        console.log(e.message);
      } finally {
        setLoadingReviewerCases(false);
      }
    };

    fetchReviewerData();
  }, []);

  const { columns, options } = getTableConfig(theme, t);
  const localization = useMemo(() => getLocalizations(t), [t]);

  return (
    <div className={classes.root}>
      <Box className={classes.table}>
        <Typography variant="h6" className={classes.titleMobile}>
          {t('Cases with reviewers')}
        </Typography>
        <MaterialTable
          title={
            <Typography variant="subtitle1" className={classes.titleLarge}>
              {t('Cases with reviewers')}
            </Typography>
          }
          icons={tableIcons}
          columns={columns}
          data={reviewerCases}
          options={options}
          localization={localization}
          isLoading={loadingReviewerCases}
        />
      </Box>
    </div>
  );
};
